import { createGlobalStyle } from "styled-components";

export const GlobalAppTheme = createGlobalStyle`

html {
  width: 100%;
  height: 100%;
}

body {
  margin: 0px;
  width: 100%;
  height: 100%;
}

#root {
  width: 100%;
  height: 100%;
}

a {
  text-decoration: none;
  outline: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
`;
